// DashboardMuiEcharts.jsx
import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Chip,
  TableContainer,
  Tooltip,
  LinearProgress,
  ToggleButtonGroup,
  ToggleButton,
  TextField,
  MenuItem,
  TablePagination,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import Navbar1 from "../Navbar/Navbar1";
import ReactECharts from "echarts-for-react";
import dayjs from "dayjs";
import axios from "axios";
import * as echarts from "echarts";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import SpeedIcon from "@mui/icons-material/Speed";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

// import axios from "axios";

const tableFont = {
  fontFamily: "Poppins, sans-serif",
};

const headerCell = {
  ...tableFont,
  fontWeight: 600,
};

const bodyCell = {
  ...tableFont,
  paddingTop: "12px",
  paddingBottom: "12px",
  fontSize: "13px",
  color: "#2e2e2e",
  borderBottom: "1px solid rgba(20, 79, 238, 0.05)",
};

const smallTextFieldSx = {
  width: 160,
  "& .MuiOutlinedInput-root": {
    height: 36,
    borderRadius: "8px",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    backgroundColor: "#ffffff",
    "& fieldset": {
      borderColor: "rgba(20, 79, 238, 0.15)",
    },
    "&:hover fieldset": {
      borderColor: "rgba(20, 79, 238, 0.4)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#144FEE",
    },
  },
  "& .MuiSelect-select": {
    padding: "8px 12px",
    fontFamily: "Poppins, sans-serif",
  },
};

const monthOptions = [
  { value: "all", label: "All Months" },
  { value: "jan", label: "January" },
  { value: "feb", label: "February" },
  { value: "mar", label: "March" },
  { value: "apr", label: "April" },
  { value: "may", label: "May" },
  { value: "jun", label: "June" },
  { value: "jul", label: "July" },
  { value: "aug", label: "August" },
  { value: "sep", label: "September" },
  { value: "oct", label: "October" },
  { value: "nov", label: "November" },
  { value: "dec", label: "December" },
];

const data = [
  { month: "Jan", productivity: "82%", efficiency: "78%", utilisation: "80%", mixerRunHrs: "320" },
  { month: "Feb", productivity: "88%", efficiency: "84%", utilisation: "86%", mixerRunHrs: "350" },
  { month: "Mar", productivity: "90%", efficiency: "87%", utilisation: "89%", mixerRunHrs: "360" },
  { month: "Apr", productivity: "85%", efficiency: "81%", utilisation: "83%", mixerRunHrs: "340" },
  { month: "May", productivity: "79%", efficiency: "76%", utilisation: "78%", mixerRunHrs: "300" },
  { month: "Jun", productivity: "91%", efficiency: "88%", utilisation: "90%", mixerRunHrs: "370" },
  { month: "Jul", productivity: "87%", efficiency: "82%", utilisation: "85%", mixerRunHrs: "345" },
  { month: "Aug", productivity: "84%", efficiency: "80%", utilisation: "82%", mixerRunHrs: "330" },
];

export default function Dashboard2() {
  const machineMacInfo =
    JSON.parse(localStorage.getItem("machineMacInfo")) || [];

  // Top Variables
  const [mac_id, setMac_id] = useState(machineMacInfo[0]?.mac_id);
  const [prod_id, setProd_id] = useState(null);

  const [selectedMonth, setSelectedMonth] = useState("all");

  // Breakdown
  const [OrderBreakdown, setOrderBreakdown] = useState([]);
  const [monthlyCompletionRate, setMonthlyCompletionRate] = useState([
    { month: "Jan", value: 40 },
    { month: "Feb", value: 40 },
    { month: "Mar", value: 40 },
    { month: "Apr", value: 45 },
    { month: "May", value: 65 },
    { month: "Jun", value: 78 }, // peak
    { month: "Jul", value: 70 },
    { month: "Aug", value: 60 },
    { month: "Sep", value: 48 },
    { month: "Oct", value: 35 },
    { month: "Nov", value: 20 },
    { month: "Dec", value: 10 },
  ]);

  const [loading, setLoading] = useState(false);
  const [chartKey, setChartKey] = useState(0);
  const [openFlowchart, setOpenFlowchart] = useState(false);
  const [selectedMetric, setSelectedMetric] = useState(null);

  const [alignment, setAlignment] = React.useState("day");

  const [dashboardChartData, setDashboardChartData] = useState([]);
  const [dashboardData, setDashboardData] = useState(null);
  const [yearlyChartData, setYearlyChartData] = useState([]);

  const [selectionDate, setSelectionDae] = useState(dayjs());
  const [startDate, setStartDate] = useState(
    dayjs().startOf("month").format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState(
    dayjs().endOf("month").format("YYYY-MM-DD"),
  );

  const [selectBar, setSelectBar] = useState("Batch Count");
  const [selectBarList, setSelectBarList] = useState([
    "Batch Count",
    "Calculate Production Quantity",
    "Rated Batch",
    "Under Rated Batch",
  ]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(6);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);

    if (newAlignment === "day") {
      setStartDate(dayjs().startOf("month").format("YYYY-MM-DD"));
      setEndDate(dayjs().endOf("month").format("YYYY-MM-DD"));
      setSelectionDae(dayjs());
    } else if (newAlignment === "month") {
      setStartDate(dayjs().startOf("year").format("YYYY-MM-DD"));
      setEndDate(dayjs().endOf("year").format("YYYY-MM-DD"));
      setSelectionDae(dayjs());
    }
  };

  const handleYearChange = (yearVal) => {
    const newDate = dayjs(selectionDate).year(parseInt(yearVal));
    setSelectionDae(newDate);

    if (alignment === "day") {
      setStartDate(newDate.startOf("month").format("YYYY-MM-DD"));
      setEndDate(newDate.endOf("month").format("YYYY-MM-DD"));
    } else if (alignment === "month") {
      setStartDate(newDate.startOf("year").format("YYYY-MM-DD"));
      setEndDate(newDate.endOf("year").format("YYYY-MM-DD"));
    }
  };

  // const [mini, setMini] = useState(sessionStorage.getItem("mini") === "true");

  // console.log(mini);

  // useEffect(() => {
  //   alert("ii");
  //   sessionStorage.setItem("mini", mini ? "true" : "false");

  //   if (mini) {
  //     setChartKey((prev) => prev + 1);
  //   }
  // }, [mini]);

  const DashboardChartApi = () => {
    const payload =
    // date: dayjs(selectDate).format("MM"),
    {
      rpt_type: alignment, //”day”/”month”/”year”
      mac_id: mac_id,
      start:
        alignment == "day"
          ? startDate
          : alignment == "month"
            ? startDate
            : "2023-01-01",
      end:
        alignment == "day"
          ? endDate
          : alignment == "month"
            ? endDate
            : dayjs().format("YYYY-MM-DD"),
    };

    const token = localStorage.getItem("token");

    axios
      .post(
        `https://iot-api.elantristechnologies.com/api/BatchingPlant/Dashboard_ProductionData`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`, // ✅ headers here
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        if (res.data.status == 1) {
          console.log(res.data);

          setDashboardChartData(res.data.data);

          setLoading(false);
        } else {
          // alert(res.data.msg);
          setDashboardChartData([]);
        }
      })
      .catch((err) => {
        alert(err);
        setLoading(false);
      });
  };

  const DashboardApi = () => {
    const selectedYear = dayjs(selectionDate).format("YYYY");
    const token = localStorage.getItem("token");

    setLoading(true);

    // Call 1: Fetch the monthly chart data for the entire selected year
    const yearlyPayload = {
      rpt_type: "month",
      mac_id: mac_id,
      start: `${selectedYear}-01-01`,
      end: `${selectedYear}-12-31`,
    };

    axios.post(
      `https://iot-api.elantristechnologies.com/api/BatchingPlant/Dashboard_ProductionData`,
      yearlyPayload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => {
      if (res.data.status === 1) {
        setYearlyChartData(res.data.data);
      } else {
        setYearlyChartData([]);
      }
      setLoading(false);
    })
    .catch((err) => {
      console.error(err);
      setLoading(false);
    });

    // Call 2: Call Dashboard_CurrentProductionData to keep real-time today value updated
    const realTimePayload = {
      mac_id: mac_id,
      prod_id: prod_id,
    };
    axios.post(
      `https://iot-api.elantristechnologies.com/api/BatchingPlant/Dashboard_CurrentProductionData`,
      realTimePayload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => {
      if (res.data.status === 1) {
        setDashboardData(res.data.data);
      }
    })
    .catch((err) => {
      console.error(err);
    });
  };

  useEffect(() => {
    if (machineMacInfo.length > 0) {
      const first = machineMacInfo[0];

      // setPlantType(first.mac_type);
      setProd_id(first.prod_id);
      setMac_id(first.mac_id);
    }
  }, []);

  useEffect(() => {
    if (mac_id != null) {
      DashboardApi();
    }
  }, [selectionDate, selectedMonth]);

  useEffect(() => {
    if (mac_id != null) {
      DashboardChartApi();
    }
  }, [alignment, selectionDate, startDate]);

  const selectedYear = dayjs(selectionDate).format("YYYY");
  const isCurrentYear = selectedYear === dayjs().format("YYYY");

  // Production values calculated dynamically from yearly chart data of selected year
  const yearProduction = yearlyChartData.reduce((sum, item) => sum + Number(item.cp_qty || 0), 0);
  const yearBatches = yearlyChartData.reduce((sum, item) => sum + Number(item.cnt || 0), 0);
  const yearRunHrs = Math.round(yearBatches * 0.333 * 100) / 100;

  const monthProduction = selectedMonth === "all"
    ? (dashboardData ? Number(dashboardData[0]?.month_value || 0) : 0)
    : (() => {
        const monthMapIdx = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };
        const targetMonthIdx = monthMapIdx[selectedMonth];
        const match = yearlyChartData.find(item => {
          const m = dayjs(item.period || item.dt).month();
          return m === targetMonthIdx;
        });
        return match ? Number(match.cp_qty || 0) : 0;
      })();

  const monthBatches = selectedMonth === "all"
    ? (dashboardData ? Number(dashboardData[1]?.month_value || 0) : 0)
    : (() => {
        const monthMapIdx = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };
        const targetMonthIdx = monthMapIdx[selectedMonth];
        const match = yearlyChartData.find(item => {
          const m = dayjs(item.period || item.dt).month();
          return m === targetMonthIdx;
        });
        return match ? Number(match.cnt || 0) : 0;
      })();

  const monthRunHrs = Math.round(monthBatches * 0.333 * 100) / 100;

  const todayProduction = isCurrentYear && dashboardData ? Number(dashboardData[0]?.today_value || 0) : 0;
  const todayBatches = isCurrentYear && dashboardData ? Number(dashboardData[1]?.today_value || 0) : 0;
  const rawTodayRunHrs = isCurrentYear && dashboardData ? Number(dashboardData[3]?.today_value || 0) : 0;
  const todayRunHrs = rawTodayRunHrs > 24 ? Math.round(todayBatches * 0.333 * 100) / 100 : rawTodayRunHrs;

  // Align concreteProduced, mixerRunHrs, and activeDays to selected card alignment (year/month/day) for metrics calculations
  let concreteProduced = 0;
  let mixerRunHrs = 0;
  let activeDays = 1;

  if (alignment === "year") {
    concreteProduced = yearProduction;
    mixerRunHrs = yearRunHrs;
    activeDays = 365;
  } else if (alignment === "month") {
    concreteProduced = monthProduction;
    mixerRunHrs = monthRunHrs;
    activeDays = dayjs(selectionDate).daysInMonth() || 30;
  } else {
    // alignment === "day"
    concreteProduced = todayProduction;
    mixerRunHrs = todayRunHrs;
    activeDays = 1;
  }

  const totalAvailableTime = activeDays * 11; // 12 hours shift minus 1 hour break = 11 hours per day

  // Calculate Metrics:
  // 1. Productivity:
  // Productivity = Total Concrete Produced (m3) / Actual Operating Time (hrs)
  const prodVal = totalAvailableTime > 0 ? (concreteProduced / totalAvailableTime) : 0;
  // Productivity Index (%) = (Productivity / Theoretical Capacity) * 100 (where Theoretical Capacity = 30)
  const productivityIndex = Math.min(100, Math.round((prodVal / 30) * 100));

  // 2. Efficiency:
  // Efficiency (%) = (Actual Productivity / Practical Capacity) * 100 (where Practical Capacity = 28)
  const efficiencyPercent = Math.min(100, Math.round((prodVal / 28) * 100));

  // 3. Utilisation:
  // Utilisation (%) = (Mixer Run Hrs / Total Available Time) * 100
  const utilisationPercent = Math.min(100, Math.round((mixerRunHrs / totalAvailableTime) * 100));

  // 4. Mixer Run Hrs Percentage:
  const mixerRunPercent = utilisationPercent;

  // 5. PHI (Production Health Index):
  const phi = Math.min(100, Math.round(0.3 * utilisationPercent + 0.4 * efficiencyPercent + 0.3 * productivityIndex));

  const statsData = [
    {
      title: "Productivity",
      percentage: productivityIndex,
      trendVal: `▲ ${productivityIndex}%`,
      displayValue: `${prodVal.toFixed(1)} m³/h`,
      subtitle: `${concreteProduced.toLocaleString(undefined, {maximumFractionDigits: 1})} Cum / ${(totalAvailableTime * 30).toLocaleString()} Target`,
      bottomTrend: "→ 7%",
      primaryColor: "#E5A93C",
      gradientEnd: "#F2C94C",
      isSegmented: true,
      year: selectedYear,
      month: selectedMonth === "all" ? "Year" : selectedMonth.toUpperCase(),
    },
    {
      title: "Efficiency",
      percentage: efficiencyPercent,
      trendVal: `▲ ${efficiencyPercent}%`,
      hasArrow: true,
      displayValue: `${efficiencyPercent.toFixed(1)}%`,
      subtitle: `${prodVal.toFixed(1)} m³/h / 28 m³/h`,
      bottomSparkline: true,
      primaryColor: "#144FEE",
      gradientEnd: "#5F83FE",
      year: selectedYear,
      month: selectedMonth === "all" ? "Year" : selectedMonth.toUpperCase(),
    },
    {
      title: "Mixer Run Hrs",
      percentage: mixerRunPercent,
      displayValue: `${mixerRunHrs.toFixed(1)}`,
      displayValueSub: `${mixerRunHrs.toFixed(1)}h`,
      subtitle: `${mixerRunHrs.toFixed(1)} hrs / ${totalAvailableTime} hrs`,
      bottomTrend: "60",
      bottomSparkline: true,
      primaryColor: "#06B6D4",
      gradientEnd: "#67e8f9",
      year: selectedYear,
      month: selectedMonth === "all" ? "Year" : selectedMonth.toUpperCase(),
    },
    {
      title: "Utilisation",
      percentage: utilisationPercent,
      trendVal: `↔ ${utilisationPercent}%`,
      hasArrow: true,
      displayValue: `${utilisationPercent}%`,
      subtitle: `${concreteProduced.toLocaleString(undefined, {maximumFractionDigits: 1})} Cum / ${utilisationPercent}%`,
      bottomSparkline: true,
      primaryColor: "#0D9488",
      gradientEnd: "#2dd4bf",
      year: selectedYear,
      month: selectedMonth === "all" ? "Year" : selectedMonth.toUpperCase(),
    },
  ];


  // Calculate averages for monthly and daily summaries
  const activeMonthsCount = yearlyChartData.filter(item => Number(item.cp_qty || 0) > 0).length || 1;
  const avgMonthlyQty = yearProduction / activeMonthsCount;

  const daysInMonth = dayjs(selectionDate).daysInMonth() || 30;
  const avgDailyQty = monthProduction / daysInMonth;

  const statsData2 = [
    {
      production: yearProduction.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      productionRaw: yearProduction,
      target: "Production Target 100k",
      targetRaw: 100000,
      runningHours: `${yearRunHrs.toLocaleString()} hrs`,
      name: `${selectedYear} Mixer Run Hours`,
    },
    {
      production: monthProduction.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      productionRaw: monthProduction,
      target: "Production Target 10k",
      targetRaw: 10000,
      runningHours: `${monthRunHrs.toLocaleString()} hrs`,
      name: `${selectedMonth === "all" ? "Monthly" : selectedMonth.charAt(0).toUpperCase() + selectedMonth.slice(1)} Mixer Run Hours`,
      avgVal: avgMonthlyQty.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    },
    {
      production: todayProduction.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      productionRaw: todayProduction,
      target: "Production Target 300",
      targetRaw: 300,
      runningHours: `${todayRunHrs.toLocaleString()} hrs`,
      name: "Today Mixer Run Hours",
      avgVal: avgDailyQty.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    },
  ];


  // Helper to map dashboardChartData to dynamic trend data for the bottom chart
  const getChartTrendData = () => {
    if (!dashboardChartData || dashboardChartData.length === 0) {
      return data.map((item) => ({
        period: item.month,
        productivity: parseInt(item.productivity),
        efficiency: parseInt(item.efficiency),
        utilisation: parseInt(item.utilisation),
        mixerRunHrs: parseInt(item.mixerRunHrs),
      }));
    }

    return dashboardChartData.map((item) => {
      const periodName =
        alignment === "day"
          ? dayjs(item.period || item.dt).format("DD")
          : alignment === "month"
            ? dayjs(item.period || item.dt).format("MMM")
            : dayjs(item.period || item.dt).format("YYYY");

      const concrete = Number(item.cp_qty || 0);
      const batches = Number(item.cnt || 0);

      let days = 1;
      if (alignment === "month") {
        days = dayjs(item.period || item.dt).daysInMonth() || 30;
      } else if (alignment === "year") {
        days = 365;
      }
      const availTime = days * 11;

      const totalBatches = alignment === "day"
        ? Number(dashboardData?.[1]?.month_value ?? 0)
        : Number(dashboardData?.[1]?.year_value ?? 0);
      const totalRunHrs = alignment === "day"
        ? monthRunHrs
        : yearRunHrs;

      const runHrs = totalBatches > 0 ? (totalRunHrs * (batches / totalBatches)) : 0;

      const prodVal = availTime > 0 ? (concrete / availTime) : 0;
      const prodIdx = Math.min(100, Math.round((prodVal / 30) * 100));
      const effPct = Math.min(100, Math.round((prodVal / 28) * 100));
      const utilPct = Math.min(100, Math.round((runHrs / availTime) * 100));

      return {
        period: periodName,
        productivity: prodIdx,
        efficiency: effPct,
        utilisation: utilPct,
        mixerRunHrs: Math.round(runHrs * 10) / 10,
      };
    });
  };

  const chartTrendData = getChartTrendData();
  const visibleRows = chartTrendData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  const appConfig = {
    position: "top",
    distance: 9,
    align: "middle",
    verticalAlign: "middle",
  };

  const labelOption = {
    show: true,
    position: appConfig.position,
    distance: appConfig.distance,
    align: appConfig.align,
    verticalAlign: appConfig.verticalAlign,
    rotate: appConfig.rotate,
    fontSize: 10,
    color: "#2e2e2e",
    fontFamily: "Poppins, sans-serif",
    rich: {
      name: {},
    },
  };

  let activeLegend = ["Productivity", "Efficiency", "Utilisation"];
  let activeSeries = [
    {
      name: "Productivity",
      type: "line",
      smooth: true,
      showSymbol: true,
      symbol: "circle",
      symbolSize: 6,
      itemStyle: {
        color: "#E5A93C",
        borderColor: "#ffffff",
        borderWidth: 2,
      },
      lineStyle: {
        width: 3.5,
        color: "#E5A93C",
        shadowColor: "rgba(229, 169, 60, 0.15)",
        shadowBlur: 10,
        shadowOffsetY: 4,
      },
      data: getChartTrendData().map((item) => item.productivity),
    },
    {
      name: "Efficiency",
      type: "line",
      smooth: true,
      showSymbol: true,
      symbol: "circle",
      symbolSize: 6,
      itemStyle: {
        color: "#144FEE",
        borderColor: "#ffffff",
        borderWidth: 2,
      },
      lineStyle: {
        width: 3.5,
        color: "#144FEE",
        shadowColor: "rgba(20, 79, 238, 0.15)",
        shadowBlur: 10,
        shadowOffsetY: 4,
      },
      data: getChartTrendData().map((item) => item.efficiency),
    },
    {
      name: "Utilisation",
      type: "line",
      smooth: true,
      showSymbol: true,
      symbol: "circle",
      symbolSize: 6,
      itemStyle: {
        color: "#0D9488",
        borderColor: "#ffffff",
        borderWidth: 2,
      },
      lineStyle: {
        width: 3.5,
        color: "#0D9488",
        shadowColor: "rgba(13, 148, 136, 0.15)",
        shadowBlur: 10,
        shadowOffsetY: 4,
      },
      data: getChartTrendData().map((item) => item.utilisation),
    },
  ];

  if (selectedMetric === "Productivity") {
    activeLegend = ["Productivity"];
    activeSeries = [
      {
        ...activeSeries[0],
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "rgba(229, 169, 60, 0.25)" },
            { offset: 1, color: "rgba(229, 169, 60, 0.01)" },
          ]),
        },
      }
    ];
  } else if (selectedMetric === "Efficiency") {
    activeLegend = ["Efficiency"];
    activeSeries = [
      {
        ...activeSeries[1],
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "rgba(20, 79, 238, 0.25)" },
            { offset: 1, color: "rgba(20, 79, 238, 0.01)" },
          ]),
        },
      }
    ];
  } else if (selectedMetric === "Utilisation") {
    activeLegend = ["Utilisation"];
    activeSeries = [
      {
        ...activeSeries[2],
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "rgba(13, 148, 136, 0.25)" },
            { offset: 1, color: "rgba(13, 148, 136, 0.01)" },
          ]),
        },
      }
    ];
  } else if (selectedMetric === "Mixer Run Hrs") {
    activeLegend = ["Mixer Run Hrs"];
    activeSeries = [
      {
        name: "Mixer Run Hrs",
        type: "line",
        smooth: true,
        showSymbol: true,
        symbol: "circle",
        symbolSize: 6,
        itemStyle: {
          color: "#06B6D4",
          borderColor: "#ffffff",
          borderWidth: 2,
        },
        lineStyle: {
          width: 3.5,
          color: "#06B6D4",
          shadowColor: "rgba(6, 182, 212, 0.15)",
          shadowBlur: 10,
          shadowOffsetY: 4,
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "rgba(6, 182, 212, 0.25)" },
            { offset: 1, color: "rgba(6, 182, 212, 0.01)" },
          ]),
        },
        data: getChartTrendData().map((item) => item.mixerRunHrs),
      }
    ];
  }

  const performanceOption = {
    backgroundColor: "transparent",
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "line", lineStyle: { color: "rgba(20, 79, 238, 0.15)", width: 1.5, type: "dashed" } },
      backgroundColor: "rgba(255, 255, 255, 0.96)",
      borderColor: "rgba(20, 79, 238, 0.1)",
      textStyle: {
        color: "#2e2e2e",
        fontFamily: "Poppins, sans-serif",
        fontSize: 12,
      },
      extraCssText: "box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05); border-radius: 8px;"
    },
    legend: {
      data: activeLegend,
      textStyle: {
        fontFamily: "Poppins, sans-serif",
        color: "#555",
      },
      bottom: 0,
    },
    grid: { left: 40, right: 15, top: 40, bottom: 45 },
    textStyle: {
      fontFamily: "Poppins, sans-serif",
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: getChartTrendData().map((item) => item.period),
      axisLine: { lineStyle: { color: "rgba(0, 0, 0, 0.08)" } },
      axisTick: { show: false },
      axisLabel: {
        color: "#777",
        fontFamily: "Poppins, sans-serif",
        fontSize: 11
      },
    },
    yAxis: {
      type: "value",
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: { show: true, lineStyle: { color: "rgba(0, 0, 0, 0.04)", type: "dashed" } },
      axisLabel: {
        color: "#777",
        fontFamily: "Poppins, sans-serif",
        fontSize: 11,
        formatter: selectedMetric === "Mixer Run Hrs" ? "{value} h" : "{value}%"
      },
    },
    series: activeSeries,
  };
  const barOption = {
    backgroundColor: "transparent",

    tooltip: {
      trigger: "axis",
      axisPointer: { type: "line", lineStyle: { color: "rgba(20, 79, 238, 0.15)", width: 1.5, type: "dashed" } },
      backgroundColor: "rgba(255, 255, 255, 0.96)",
      borderColor: "rgba(20, 79, 238, 0.1)",
      textStyle: {
        color: "#2e2e2e",
        fontFamily: "Poppins, sans-serif",
        fontSize: 12
      },
      extraCssText: "box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05); border-radius: 8px;"
    },

    grid: { left: 45, right: 20, top: 30, bottom: 25 },

    textStyle: {
      fontFamily: "Poppins, sans-serif",
    },

    xAxis: {
      type: "category",
      boundaryGap: false,
      data:
        alignment == "day"
          ? dashboardChartData.map((item) => dayjs(item.period).format("DD"))
          : alignment == "month"
            ? dashboardChartData.map((item) => dayjs(item.period).format("MMM"))
            : dashboardChartData.map((item) =>
              dayjs(item.period).format("YYYY"),
            ),
      axisLine: { lineStyle: { color: "rgba(20, 79, 238, 0.1)" } },
      axisTick: { show: false },
      axisLabel: {
        color: "#777",
        fontFamily: "Poppins, sans-serif",
        fontSize: 11
      },
    },

    yAxis: {
      type: "value",
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: { show: true, lineStyle: { color: "rgba(20, 79, 238, 0.05)", type: "dashed" } },
      axisLabel: {
        color: "#777",
        fontFamily: "Poppins, sans-serif",
        fontSize: 11
      },
    },

    series: [
      {
        type: "line",
        smooth: true,
        label: labelOption,

        data: dashboardChartData.map((item) =>
          selectBar == "Batch Count"
            ? +Number(item.cnt || 0).toFixed(2)
            : selectBar == "Calculate Production Quantity"
              ? +Number(item.cp_qty || 0).toFixed(2)
              : selectBar == "Rated Batch"
                ? +Number(item.rate || 0).toFixed(2)
                : selectBar == "Under Rated Batch"
                  ? +Number(item.unrate || 0).toFixed(2)
                  : 0,
        ),

        lineStyle: {
          color: "#144FEE",
          width: 3.5,
          shadowColor: "rgba(20, 79, 238, 0.15)",
          shadowBlur: 10,
          shadowOffsetY: 4,
        },

        itemStyle: {
          color: "#144FEE",
          borderColor: "#ffffff",
          borderWidth: 2,
          shadowColor: "rgba(20, 79, 238, 0.3)",
          shadowBlur: 8,
        },

        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "rgba(20, 79, 238, 0.25)" },
            { offset: 1, color: "rgba(20, 79, 238, 0.01)" },
          ]),
        },
      },
    ],
  };

  // const handleBarClick = (params) => {
  //   const monthName = params.name;
  //   const monthNumber = monthMap.indexOf(monthName) + 1;

  //   const monthString = String(monthNumber).padStart(2, "0"); // 👉 Convert to string "01"

  //   console.log("Month String:", monthString);

  //   const currentYear = dayjs(selectDate).format("YYYY");
  //   const newDate = dayjs(`${currentYear}-${monthString}-01`);

  //   setMonth(monthString); // 👉 now sending string month
  //   setSeletDate(newDate);
  //   setYear(currentYear);
  // };

  const cellStyle = {
    fontFamily: "Poppins, sans-serif",
    fontSize: "14px",
    color: "#000",
    whiteSpace: "nowrap",
    paddingTop: "10px",
    paddingBottom: "10px",
  };

  const percentage = 78;

  const primaryColor = "#0066FF";



  return (
    <div>
      <Navbar1>
        <Box
          sx={{
            p: 2,
            bgcolor: "#F3F9F3",
            height: "calc(100vh - 64px)",
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            boxSizing: "border-box",
            overflow: "hidden",
          }}
        >
          {/* Header Area */}
          <Paper
            sx={{
              p: 1.5,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.04)",
              borderRadius: "12px",
              border: "1px solid rgba(20, 79, 238, 0.08)",
              bgcolor: "#ffffff",
            }}
          >
            <Box display="flex" alignItems="center" gap={2}>
              <Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      color: "#144FEE",
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "1.1rem",
                    }}
                  >
                    Overall Performance Matrix
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      color: "#555",
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "1.1rem",
                    }}
                  >
                    - {sessionStorage.getItem("comp_name") || "Elantris Admin"}
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    fontSize: "11px",
                    color: "#777",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  Real-time concrete production and machinery performance overview.
                </Typography>
              </Box>
            </Box>

            <Box display="flex" alignItems="center" gap={1.5}>
              <Chip
                icon={<FiberManualRecordIcon sx={{ fontSize: "10px !important", color: "#10B981" }} />}
                label="Mixer-01 (Online)"
                size="small"
                sx={{
                  bgcolor: "rgba(16, 185, 129, 0.1)",
                  color: "#10B981",
                  fontWeight: 600,
                  fontFamily: "Poppins, sans-serif",
                  fontSize: "11px",
                  border: "1px solid rgba(16, 185, 129, 0.2)",
                  height: 28,
                }}
              />
              <Chip
                label="Shift A"
                size="small"
                sx={{
                  bgcolor: "rgba(20, 79, 238, 0.08)",
                  color: "#144FEE",
                  fontWeight: 600,
                  fontFamily: "Poppins, sans-serif",
                  fontSize: "11px",
                  border: "1px solid rgba(20, 79, 238, 0.15)",
                  height: 28,
                }}
              />

              <Box sx={{ width: "1px", bgcolor: "rgba(0, 0, 0, 0.08)", mx: 0.5, height: 20 }} />

              {/* Year filter */}
              <Box display='flex' alignItems='center' gap={1}>
                <Typography sx={{ color: "#555", fontFamily: "Poppins, sans-serif", fontSize: "11px", fontWeight: 500 }}>
                  Year:
                </Typography>
                <TextField
                  select
                  size='small'
                  value={dayjs(selectionDate).format("YYYY")}
                  onChange={(e) => handleYearChange(e.target.value)}
                  sx={{
                    ...smallTextFieldSx,
                    width: 85,
                    "& .MuiOutlinedInput-root": {
                      ...smallTextFieldSx["& .MuiOutlinedInput-root"],
                      height: 28,
                      fontSize: "11px",
                    }
                  }}
                >
                  {["2023", "2024", "2025", "2026", "2027", "2028"].map((year) => (
                    <MenuItem key={year} value={year} sx={{ fontSize: "11px", fontFamily: "Poppins" }}>
                      {year}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>

              {/* Month filter */}
              <Box display='flex' alignItems='center' gap={1}>
                <Typography sx={{ color: "#555", fontFamily: "Poppins, sans-serif", fontSize: "11px", fontWeight: 500 }}>
                  Month:
                </Typography>
                <TextField
                  select
                  size='small'
                  value={selectedMonth}
                  onChange={(e) => {
                    const newMonth = e.target.value;
                    setSelectedMonth(newMonth);
                    // Update alignment and dates based on month selection
                    if (newMonth === "all") {
                      setAlignment("month");
                      const newDate = dayjs(selectionDate);
                      setStartDate(newDate.startOf("year").format("YYYY-MM-DD"));
                      setEndDate(newDate.endOf("year").format("YYYY-MM-DD"));
                    } else {
                      setAlignment("day");
                      const monthMapIdx = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };
                      const monthIdx = monthMapIdx[newMonth];
                      const newDate = dayjs(selectionDate).month(monthIdx);
                      setSelectionDae(newDate);
                      setStartDate(newDate.startOf("month").format("YYYY-MM-DD"));
                      setEndDate(newDate.endOf("month").format("YYYY-MM-DD"));
                    }
                  }}
                  sx={{
                    ...smallTextFieldSx,
                    width: 100,
                    "& .MuiOutlinedInput-root": {
                      ...smallTextFieldSx["& .MuiOutlinedInput-root"],
                      height: 28,
                      fontSize: "11px",
                    }
                  }}
                >
                  {monthOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value} sx={{ fontSize: "11px", fontFamily: "Poppins" }}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </Box>
          </Paper>

          {/* Main Dashboard Workspace (split vertically) */}
          <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1.5, overflow: "hidden" }}>
            
            {/* Top Grid: Metrics Card & Summary Cards */}
            <Box sx={{ height: "calc(49% - 6px)", display: "flex", gap: 1.5 }}>
              
              {/* Left Card: Overall Performance Metrics */}
              <Box sx={{ width: "58.33%" }}>
                <Paper
                  sx={{
                    p: 2,
                    border: "1px solid rgba(0, 0, 0, 0.08)",
                    background: "#ffffff",
                    borderRadius: "12px",
                    boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.04)",
                    fontFamily: "Poppins, sans-serif",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    boxSizing: "border-box",
                    overflow: "hidden",
                  }}
                >
                  {/* Title */}
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "#1a2035",
                      fontFamily: "Poppins, sans-serif",
                      mb: 1,
                    }}
                  >
                    Overall Performance Metrics ({alignment === "year" ? "Yearly" : alignment === "month" ? "Monthly" : "Today"})
                  </Typography>

                  {/* Production Health Index Section */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 1.5,
                    }}
                  >
                    {/* Left: Title & Progress */}
                    <Box sx={{ flex: 1 }}>
                      <Box display="flex" alignItems="center" gap={1.5}>
                        <Typography
                          sx={{
                            fontSize: 13,
                            fontWeight: 600,
                            color: "#555",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Production Health Index
                        </Typography>
                        <Box display="flex" alignItems="baseline">
                          <Typography
                            sx={{
                              fontSize: "1.5rem",
                              fontWeight: 700,
                              color: "#E5A93C",
                              fontFamily: "Poppins, sans-serif",
                              lineHeight: 1,
                            }}
                          >
                            {phi}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.9rem",
                              fontWeight: 600,
                              color: "#bbb",
                              fontFamily: "Poppins, sans-serif",
                              ml: 0.2,
                            }}
                          >
                            /100
                          </Typography>
                        </Box>
                      </Box>
                      
                      {/* Segmented progress */}
                      <Box display="flex" gap={0.5} mt={0.5} width="200px">
                        {[1, 2, 3, 4, 5].map((s) => (
                          <Box
                            key={s}
                            sx={{
                              flex: 1,
                              height: 6,
                              borderRadius: "2px",
                              bgcolor: s <= Math.round(phi / 20) ? "#E5A93C" : "rgba(229, 169, 60, 0.15)"
                            }}
                          />
                        ))}
                      </Box>
                    </Box>

                    {/* Right: Operation Area */}
                    <Box display="flex" alignItems="center" gap={1}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: 32,
                          height: 32,
                          borderRadius: "50%",
                          border: "1px solid rgba(16, 185, 129, 0.2)",
                          bgcolor: "rgba(16, 185, 129, 0.05)",
                          color: "#10B981"
                        }}
                      >
                        <TrendingUpIcon sx={{ fontSize: 16 }} />
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "10px",
                            color: "#777",
                            fontWeight: 500,
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Operation Area
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            color: "#10B981",
                            fontWeight: 700,
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          +7%
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  <Box sx={{ borderBottom: "1px solid rgba(0, 0, 0, 0.08)", mb: 0.5 }} />

                  {/* 2x2 Grid of metrics */}
                  <Grid container sx={{ flex: 1, alignContent: "stretch", height: "100%" }}>
                    {statsData.map((item, index) => {
                      const isLeft = index % 2 === 0;
                      const isTop = index < 2;
                      const isSelected = selectedMetric === item.title;
                      
                      return (
                        <Grid
                          size={{ xs: 6 }}
                          key={index}
                          onClick={() => {
                            if (selectedMetric === item.title) {
                              setSelectedMetric(null);
                            } else {
                              setSelectedMetric(item.title);
                            }
                          }}
                          sx={{
                            borderRight: isLeft ? "1px solid rgba(0, 0, 0, 0.08)" : "none",
                            borderBottom: isTop ? "1px solid rgba(0, 0, 0, 0.08)" : "none",
                            p: 1.2,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            height: "50%",
                            boxSizing: "border-box",
                            cursor: "pointer",
                            transition: "all 0.2s ease-in-out",
                            backgroundColor: isSelected ? "rgba(20, 79, 238, 0.05)" : "transparent",
                            boxShadow: isSelected ? "inset 0 0 0 1.5px #144FEE" : "none",
                            "&:hover": {
                              backgroundColor: isSelected ? "rgba(20, 79, 238, 0.08)" : "rgba(20, 79, 238, 0.03)",
                            },
                          }}
                        >
                          {/* Top Row: Title & Trend */}
                          <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography
                              sx={{
                                fontSize: "11px",
                                fontWeight: 600,
                                color: "#555",
                                fontFamily: "Poppins, sans-serif",
                              }}
                            >
                              {item.title}
                            </Typography>
                            
                            <Box display="flex" alignItems="center" gap={0.5}>
                              {item.trendVal && (
                                <Typography
                                  sx={{
                                    fontSize: "10px",
                                    fontWeight: 700,
                                    color: item.primaryColor,
                                    fontFamily: "Poppins, sans-serif",
                                  }}
                                >
                                  {item.trendVal}
                                </Typography>
                              )}
                              {item.hasArrow && (
                                <Typography sx={{ fontSize: "9px", color: "#bbb", fontWeight: 700 }}>
                                  &gt;
                                </Typography>
                              )}
                            </Box>
                          </Box>

                          {/* Progress Line */}
                          <Box mt={0.3}>
                            {item.isSegmented ? (
                              <Box display="flex" gap={0.4} width="100%">
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((s) => (
                                  <Box
                                    key={s}
                                    sx={{
                                      flex: 1,
                                      height: 4,
                                      borderRadius: "1px",
                                      bgcolor: s <= Math.round(item.percentage / 10) ? item.primaryColor : "rgba(229, 169, 60, 0.15)"
                                    }}
                                  />
                                ))}
                              </Box>
                            ) : (
                              <Box
                                sx={{
                                  position: "relative",
                                  height: 4,
                                  background: "#F0F4FF",
                                  overflow: "hidden",
                                  borderRadius: "3px",
                                }}
                              >
                                <Box
                                  sx={{
                                    width: `${item.percentage}%`,
                                    height: "100%",
                                    background: `linear-gradient(90deg, ${item.primaryColor}, ${item.gradientEnd})`,
                                    borderRadius: "3px",
                                  }}
                                />
                              </Box>
                            )}
                          </Box>

                          {/* Value Row */}
                          <Box display="flex" justifyContent="flex-end" alignItems="flex-end" sx={{ mt: 0.3 }}>
                            <Box display="flex" flexDirection="column" alignItems="flex-end">
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  fontWeight: 700,
                                  color: "#2e2e2e",
                                  fontFamily: "Poppins, sans-serif",
                                  lineHeight: 1
                                }}
                              >
                                {item.displayValue}
                              </Typography>
                              {item.displayValueSub && (
                                <Typography
                                  sx={{
                                    fontSize: "9px",
                                    fontWeight: 600,
                                    color: "#555",
                                    fontFamily: "Poppins, sans-serif",
                                    mt: 0.1,
                                    lineHeight: 1
                                  }}
                                >
                                  {item.displayValueSub}
                                </Typography>
                              )}
                            </Box>
                          </Box>

                          {/* Bottom Row: Subtitle & Sparkline */}
                          <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mt: 0.3, borderTop: "1px solid rgba(20, 79, 238, 0.04)", pt: 0.3 }}>
                            <Typography
                              sx={{
                                fontSize: "9px",
                                color: "#777",
                                fontFamily: "Poppins, sans-serif",
                                fontWeight: 500
                              }}
                            >
                              {item.subtitle}
                            </Typography>

                            {/* Right side graph / trend */}
                            {item.title === "Productivity" && (
                              <Typography
                                sx={{
                                  fontSize: "9px",
                                  fontWeight: 700,
                                  color: item.primaryColor,
                                  fontFamily: "Poppins, sans-serif",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.2
                                }}
                              >
                                → 7%
                              </Typography>
                            )}

                            {item.title === "Efficiency" && (
                              <svg width="36" height="10" viewBox="0 0 36 10" style={{ opacity: 0.8 }}>
                                <path d="M0,7 Q8,1 16,8 T32,2" fill="none" stroke={item.primaryColor} strokeWidth="1.5" />
                              </svg>
                            )}

                            {item.title === "Mixer Run Hrs" && (
                              <Box display="flex" alignItems="center" gap={0.5}>
                                <svg width="24" height="10" viewBox="0 0 24 10" style={{ opacity: 0.8 }}>
                                  <path d="M0,8 Q6,1 12,7 T24,1" fill="none" stroke={item.primaryColor} strokeWidth="1.5" />
                                </svg>
                                <Typography sx={{ fontSize: "8px", color: "#777", fontWeight: 700, fontFamily: "Poppins" }}>
                                  60
                                </Typography>
                              </Box>
                            )}

                            {item.title === "Utilisation" && (
                              <svg width="32" height="10" viewBox="0 0 32 10" style={{ opacity: 0.8 }}>
                                <path d="M0,8 L8,1 L16,6 L24,1" fill="none" stroke={item.primaryColor} strokeWidth="1.5" />
                              </svg>
                            )}
                          </Box>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Paper>
              </Box>

              {/* Right Card Column: 3 stacked summary cards */}
              <Box sx={{ width: "41.67%", display: "flex", flexDirection: "column", gap: 1, height: "100%", boxSizing: "border-box" }}>
                {statsData2.map((item, index) => {
                  const cardAlignment = index === 0 ? "year" : index === 1 ? "month" : "day";
                  const isActive = alignment === cardAlignment;
                  return (
                    <Box
                      key={index}
                      onClick={() => {
                        setAlignment(cardAlignment);
                        if (cardAlignment === "day") {
                          setStartDate(dayjs(selectionDate).startOf("month").format("YYYY-MM-DD"));
                          setEndDate(dayjs(selectionDate).endOf("month").format("YYYY-MM-DD"));
                        } else if (cardAlignment === "month") {
                          setStartDate(dayjs(selectionDate).startOf("year").format("YYYY-MM-DD"));
                          setEndDate(dayjs(selectionDate).endOf("year").format("YYYY-MM-DD"));
                        }
                      }}
                      sx={{
                        flex: 1,
                        cursor: "pointer",
                        border: isActive ? "2px solid #144FEE" : "1px solid rgba(0, 0, 0, 0.08)",
                        borderRadius: "12px",
                        background: isActive ? "rgba(20, 79, 238, 0.02)" : "#ffffff",
                        boxShadow: isActive ? "0px 6px 20px rgba(20, 79, 238, 0.08)" : "0px 6px 20px rgba(0, 0, 0, 0.04)",
                        p: 1.2,
                        boxSizing: "border-box",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        overflow: "hidden",
                        transition: "all 0.2s ease-in-out",
                        "&:hover": {
                          transform: "translateY(-1px)",
                          boxShadow: "0px 8px 25px rgba(20, 79, 238, 0.12)",
                          borderColor: "#144FEE",
                        }
                      }}
                    >
                      {/* Top row: Production (large) on the left, Target on the right */}
                      <Box display="flex" justifyContent="space-between" alignItems="baseline" sx={{ position: "relative" }}>
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "9px",
                              fontWeight: 600,
                              color: "#144FEE",
                              fontFamily: "Poppins, sans-serif",
                              textTransform: "uppercase",
                              letterSpacing: "0.5px",
                            }}
                          >
                             {index === 0
                               ? `Yearly Summary (${dayjs(selectionDate).format("YYYY")})`
                               : index === 1
                                 ? `Monthly Summary (${dayjs(selectionDate).format("MMM YY")})`
                                 : "Today's Summary"}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "1.05rem",
                              fontWeight: 700,
                              color: "#2e2e2e",
                              fontFamily: "Poppins, sans-serif",
                              mt: 0.1,
                              display: "flex",
                              alignItems: "baseline"
                            }}
                          >
                            {item.production}
                            <Box component="span" sx={{ fontSize: "10px", fontWeight: 500, color: "#666", ml: 0.4 }}>
                              Cu.m
                            </Box>
                          </Typography>
                        </Box>
                        {item.avgVal && (
                          <Box
                            sx={{
                              position: "absolute",
                              left: "50%",
                              transform: "translateX(-50%)",
                              bottom: 0,
                              display: "flex",
                              alignItems: "baseline"
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "13px",
                                fontWeight: 600,
                                color: "#555",
                                fontFamily: "Poppins, sans-serif",
                                display: "flex",
                                alignItems: "baseline"
                              }}
                            >
                              Avg: {item.avgVal}
                              <Box component="span" sx={{ fontSize: "9px", fontWeight: 500, color: "#777", ml: 0.3 }}>
                                Cu.m
                              </Box>
                            </Typography>
                          </Box>
                        )}
                        <Typography
                          sx={{
                            fontSize: "9px",
                            color: "#777",
                            fontFamily: "Poppins, sans-serif",
                            fontWeight: 500,
                          }}
                        >
                          {item.target}
                        </Typography>
                      </Box>

                      <Box sx={{ borderBottom: "1px solid rgba(0, 0, 0, 0.06)", my: 0.3 }} />

                      {/* Bottom row: Running Hours label on left, value on right */}
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography
                          sx={{
                            fontSize: "11px",
                            color: "#555",
                            fontFamily: "Poppins, sans-serif",
                            fontWeight: 500
                          }}
                        >
                          Machine run hours
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "11px",
                            fontWeight: 600,
                            color: "#2e2e2e",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          {item.runningHours}
                        </Typography>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>

            {/* Bottom Grid: Table & Bar Chart */}
            <Box sx={{ height: "calc(51% - 6px)", display: "flex", gap: 1.5 }}>
              
              {/* Left Column: Bar Chart */}
              <Box sx={{ width: "58.33%" }}>
                <Paper
                  sx={{
                    p: 2,
                    boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.06)",
                    borderRadius: "12px",
                    border: "1px solid rgba(20, 79, 238, 0.08)",
                    background: "#ffffff",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    boxSizing: "border-box",
                    overflow: "hidden"
                  }}
                >
                  <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "14px",
                        color: "#2e2e2e",
                        fontFamily: "Poppins, sans-serif",
                      }}
                    >
                      Performance Overview {selectedMetric ? `- ${selectedMetric}` : ""} ({alignment === "year" ? "Yearly" : alignment === "month" ? "Monthly" : "Daily"})
                    </Typography>
                    {selectedMetric && (
                      <Button
                        size="small"
                        onClick={() => setSelectedMetric(null)}
                        sx={{
                          textTransform: "none",
                          fontSize: "11px",
                          fontFamily: "Poppins, sans-serif",
                          color: "#144FEE",
                          p: 0,
                          minWidth: 0,
                          "&:hover": {
                            backgroundColor: "transparent",
                            textDecoration: "underline"
                          }
                        }}
                      >
                        Reset
                      </Button>
                    )}
                  </Box>

                  <Box sx={{ flex: 1, minHeight: 0 }}>
                    <ReactECharts
                      option={performanceOption}
                      style={{ height: "100%", width: "100%" }}
                      key={`${chartKey}-${selectedMetric}`}
                    />
                  </Box>
                </Paper>
              </Box>

              {/* Right Column: Table */}
              <Box sx={{ width: "41.67%" }}>
                <Paper
                  sx={{
                    p: 2,
                    boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.06)",
                    borderRadius: "12px",
                    border: "1px solid rgba(20, 79, 238, 0.08)",
                    background: "#ffffff",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    boxSizing: "border-box",
                    overflow: "hidden"
                  }}
                >
                  <TableContainer sx={{ flex: 1, maxHeight: "calc(100% - 40px)", overflowY: "auto" }}>
                    <Table stickyHeader size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell
                            sx={{
                              fontWeight: 600,
                              color: "#144FEE",
                              fontFamily: "Poppins, sans-serif",
                              fontSize: "12px",
                              bgcolor: "rgba(20, 79, 238, 0.05)",
                              borderBottom: "1px solid rgba(20, 79, 238, 0.1)",
                              p: 1
                            }}
                          >
                            Month
                          </TableCell>
                          <TableCell
                            align='right'
                            sx={{
                              fontWeight: 600,
                              color: "#144FEE",
                              fontFamily: "Poppins, sans-serif",
                              fontSize: "12px",
                              bgcolor: "rgba(20, 79, 238, 0.05)",
                              borderBottom: "1px solid rgba(20, 79, 238, 0.1)",
                              p: 1
                            }}
                          >
                            Productivity
                          </TableCell>
                          <TableCell
                            align='right'
                            sx={{
                              fontWeight: 600,
                              color: "#144FEE",
                              fontFamily: "Poppins, sans-serif",
                              fontSize: "12px",
                              bgcolor: "rgba(20, 79, 238, 0.05)",
                              borderBottom: "1px solid rgba(20, 79, 238, 0.1)",
                              p: 1
                            }}
                          >
                            Efficiency
                          </TableCell>
                          <TableCell
                            align='right'
                            sx={{
                              fontWeight: 600,
                              color: "#144FEE",
                              fontFamily: "Poppins, sans-serif",
                              fontSize: "12px",
                              bgcolor: "rgba(20, 79, 238, 0.05)",
                              borderBottom: "1px solid rgba(20, 79, 238, 0.1)",
                              p: 1
                            }}
                          >
                            Utilisation
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {visibleRows.map((row, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              backgroundColor:
                                index % 2 === 0 ? "#ffffff" : "#fcfdfe",
                              "&:hover": {
                                backgroundColor: "rgba(20, 79, 238, 0.02)",
                              },
                            }}
                          >
                            <TableCell sx={{ ...bodyCell, p: 0.8 }}>{row.period}</TableCell>
                            <TableCell sx={{ ...bodyCell, p: 0.8 }} align='right'>
                              {row.productivity}%
                            </TableCell>
                            <TableCell align='right' sx={{ ...bodyCell, p: 0.8 }}>
                              {row.efficiency}%
                            </TableCell>
                            <TableCell align='right' sx={{ ...bodyCell, p: 0.8 }}>
                              {row.utilisation}%
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <TablePagination
                    rowsPerPageOptions={[6]}
                    component='div'
                    count={chartTrendData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    sx={{
                      fontFamily: "Poppins, sans-serif",
                      minHeight: "40px",
                      "& .MuiTablePagination-toolbar": {
                        minHeight: "40px",
                        height: "40px",
                        p: 0
                      },
                      "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "11px",
                      },
                      "& .MuiTablePagination-select": {
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "11px",
                      }
                    }}
                  />
                </Paper>
              </Box>
            </Box>
          </Box>
        </Box>
      </Navbar1>
    </div>
  );
}
